
/* styles */
require("!!../../../../../../../azure/movemais.client/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/style-rewriter?id=data-v-394c262f&scoped=true!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=styles&index=0!./for-business.vue")

var Component = require("!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=script&index=0!./for-business.vue"),
  /* template */
  require("!!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/template-compiler?id=data-v-394c262f!../../../../../../../azure/movemais.client/node_modules/vue-loader/lib/selector?type=template&index=0!./for-business.vue"),
  /* scopeId */
  "data-v-394c262f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/external/for-business.vue
// module id = 1998
// module chunks = 1